module.exports = __webpack_public_path__ + "img/vi_get.9a61b28.png";